{
  "tabs": {
    "lintTriage": "Lint Triage",
    "testFailures": "Test Failures",
    "playwrightTests": "Playwright Tests"
  },
  "fixWithClaudeDialog": {
    "title": "Fix with Claude - {{fileName}}",
    "runningInBackground": "Running in background (dialog can be closed)",
    "startingClaude": "Starting Claude...",
    "fileChangesAccordion": "File Changes (git diff)",
    "noChangesDetected": "No changes detected",
    "status": {
      "success": "✅ Fix completed successfully!",
      "cancelled": "⚠️ Fix cancelled",
      "error": "❌ Fix failed (see output above)"
    },
    "buttons": {
      "cancel": "Cancel",
      "clear": "Clear",
      "close": "Close"
    }
  },
  "playwrightTests": {
    "title": "Playwright Tests",
    "loading": "Loading Playwright tests...",
    "testCount": "{{count}} tests · Est. {{duration}}",
    "buttons": {
      "retry": "Retry",
      "runningTests": "Running Tests...",
      "runAllTests": "Run All Tests"
    },
    "alerts": {
      "noTestsFound": "No Playwright test results found. Click \"Run All Tests\" to execute the test suite.",
      "runningTests": "Running Playwright tests... This may take a few minutes."
    },
    "execution": {
      "started": "Test execution started ({{processId}})",
      "completed": "\nTest execution completed with code {{code}}"
    }
  },
  "fileCard": {
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total"
    },
    "buttons": {
      "viewErrors": "View Errors",
      "copyAll": "Copy All for Claude",
      "fixAllWithClaude": "Fix All with Claude",
      "viewProgress": "View Progress...",
      "fixed": "Fixed ✓",
      "fixFailed": "Fix Failed ✗"
    }
  },
  "fileErrorsView": {
    "buttons": {
      "backToFiles": "Back to Files",
      "copyAllErrors": "Copy All {{count}} Errors",
      "openInVSCode": "Open in VSCode",
      "copyIndividual": "Copy Individual"
    },
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "total",
      "line": "Line {{number}}"
    },
    "snackbar": {
      "copiedAll": "Copied all {{count}} errors for Claude!",
      "copiedLine": "Copied error from line {{line}}"
    }
  },
  "playwrightTestDetail": {
    "buttons": {
      "backToTests": "Back to Tests",
      "viewScreenshots": "View Screenshots ({{count}})",
      "viewVideos": "View Videos ({{count}})",
      "updateSnapshots": "Update Snapshots",
      "updating": "Updating...",
      "fixWithClaude": "Fix with Claude"
    },
    "labels": {
      "errorMessage": "Error Message:"
    },
    "messages": {
      "testPassed": "This test passed successfully!",
      "snapshotsUpdated": "Snapshots updated successfully!",
      "snapshotsFailed": "Failed to update snapshots. Check console for details.",
      "error": "Error: {{message}}",
      "claudeComingSoon": "Claude fix integration coming soon!"
    }
  }
}
